import { Controller } from "@hotwired/stimulus"

// Controls the Ready Aware video gallery: switches the main iframe when a
// thumbnail card is clicked and keeps the active card highlighted.
export default class extends Controller {
  static targets = ["player", "card"]

  connect() {
    if (this.hasCardTarget) {
      this.activate(this.cardTargets[0])
    }
  }

  swap(event) {
    event.preventDefault()
    const card = event.currentTarget
    this.activate(card)
  }

  activate(card) {
    const videoUrl = card.dataset.videoUrl
    if (!videoUrl || !this.hasPlayerTarget) return

    this.cardTargets.forEach((c) => {
      c.classList.remove("ring-2", "ring-harman-blue", "shadow-sm")
    })

    card.classList.add("ring-2", "ring-harman-blue", "shadow-sm")
    this.playerTarget.src = videoUrl
    this.playerTarget.play()
  }
}
